import ASelect from "aloha-vue/src/ui/ASelect/ASelect";
import PuxIconSlot from "../../PuxIconSlot/PuxIconSlot.vue";

import UIComponentMixin from "../UIComponentMixin";

import IconsAPI from "../../../compositionAPI/IconsAPI";

// @vue/component
export default {
  name: "UiSelectIcons",
  components: {
    ASelect,
    PuxIconSlot,
  },
  mixins: [
    UIComponentMixin,
  ],
  props: {
    model: {
      type: String,
      default: undefined,
    },
  },
  setup() {
    const {
      iconsListStandard,
    } = IconsAPI();

    return {
      iconsListStandard,
    };
  },
  methods: {
    onChange({ model }) {
      this.onInput_mixin({ value: model });
    },
  },
};
